import React from 'react';
import { CTABand } from '../../components/CTABand';
export function KidsMartialArtsFinalCTA() {
  return <CTABand headline="Find the Right Kids Class at Storm" copy="Storm will help you choose the best starting class for your child's age and experience." data-id="element-2119" />;
}